import Vue from "vue";
import Vuex from "vuex";
import propertyModule from "./property.js";
import evictionModule from "./eviction.js";
import globalModule from "./global.js";
import attorneyModule from "./attorney.js";
import messageModule from "./message.js";
import eventModule from "./event.js";
import router from "@/router";
import useRequest from "@/utils/useRequest.js";
Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    property: propertyModule,
    eviction: evictionModule,
    global: globalModule,
    attorney: attorneyModule,
    message: messageModule,
    event: eventModule,
  },
  state: {
    status: "",
    token: localStorage.getItem("acc_token") || "",
    auth: false,
    authLoaded: false,
    errorMsg: "",
    loading: false,
    upcoming: false,
    client: {},
    contactInfos: [],
  },
  getters: {
    authLoaded: (state) => () => state.authLoaded,
    isAuthenticated: (state) => state.auth,
    authStatus: (state) => state.status,
    errorMsg: (state) => state.errorMsg,
    loading: (state) => state.loading,
    upcoming: (state) => state.upcoming,
    client: (state) => state.client,
    contactInfos: (state) => state.contactInfos,
  },
  actions: {
    async guestInitialSetup({ dispatch, commit }) {
      console.log("guestInitialSetup");
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      commit("set_client", userData);

      await dispatch(
        "eviction/loadCase",
        { logMessage: "store.js.vue at line 223" },
        { root: true }
      );
    },
    // eslint-disable-next-line
    async initialSetup({ commit, dispatch }) {
      try {
        const { data: client } = await useRequest({
          path: "client",
          throwError: true,
        });
        commit("set_client", client);

        await dispatch("eviction/loadCases");

        const { name, params, path } = router.currentRoute;
        if (!name) router.push("/"); //*If user goes to '/verified-complaint

        //* If in property or in VC, then get currentProperty and currentCase
        const paramId = params.id;
        if (name.startsWith("vc-") && paramId === "new") {
          //* User reloaded page before completing varifeid complaint (not a guest)
          router.push({ name: "vc-before-creating" });
          return;
        }

        if (paramId && paramId !== "new") {
          if (name.startsWith("vc-") || name.startsWith("saf-")) {
            const caseId = paramId;
            console.log("caseId :>> ", caseId);
            await dispatch(
              "eviction/loadCase",
              { caseId, logMessage: "store.js.vue at line 259" },
              { root: true }
            );
          } else if (path.startsWith("/properties")) {
            const propertyId = paramId;
            await dispatch("property/loadProperty", propertyId, { root: true });
          } else if (
            path.startsWith("/case-view") ||
            path.endsWith("/order-details")
          ) {
            const caseId = paramId;
            await dispatch(
              "eviction/loadCase",
              { caseId, logMessage: "store.js.vue at line 261" },
              { root: true }
            );
          }
        }

        return;
      } catch (err) {
        console.log("initialSetup error:", err);
        throw new Error(err);
      }
    },
    async updateUser({ getters, commit }, userData) {
      console.log("updateUser userData :>> ", userData);
      if (!getters.isAuthenticated) {
        const prevUserData = JSON.parse(sessionStorage.getItem("userData"));
        sessionStorage.setItem(
          "userData",
          JSON.stringify({ ...prevUserData, ...userData })
        );
        return;
      }
      await useRequest({
        method: "put",
        path: "api/update-user",
        data: { user: userData },
      });

      const updatedClient = { ...getters.client, ...userData };
      commit("set_client", updatedClient);
    },
    async loadContactInfos({ commit, rootGetters }) {
      if (!rootGetters.isAuthenticated) {
        console.log("unauthenticated, I will not load contact infos");
        return;
      }
      await useRequest({
        path: `contactInfos`,
        onSuccess: (contactInfos) => commit("set_contactInfos", contactInfos),
      });
    },
  },
  mutations: {
    // mutations for authorization
    set_auth(state, auth) {
      state.auth = auth;
    },
    set_auth_loaded(state, loaded) {
      state.authLoaded = loaded;
    },
    set_auth_error(state, err) {
      state.errorMsg = err;
    },
    // mutations for application
    set_loading(state, flag) {
      state.loading = flag;
    },
    set_upcoming(state, flag) {
      state.upcoming = flag;
    },
    set_client(state, client) {
      state.client = client;
    },
    set_contactInfos(state, contactInfos) {
      state.contactInfos = contactInfos;
    },
  },
});
